var SocialContactType = {
    TELEGRAM: 1,
    IMO: 2,
    WHATSAPP: 3,
    NONE: 4,
}

export { SocialContactType }
